import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { BiExit, BiPlus } from "react-icons/bi";
import {
  HiOutlineClipboardDocumentCheck,
  HiOutlineCurrencyDollar,
  HiOutlineDocumentText,
} from "react-icons/hi2";
import CustomButton from "components/common/Button/CustomButton";
import SelectOption from "components/common/Select/Select";
import SideBar from "components/common/SideBar/SideBarNew";
import TableHeader from "components/common/Table/TableHeader";

import { LoginContext } from "helpers/LoginContext";
import CheckBox from "components/common/checkBox/checkbox";
import { connect } from "react-redux";
import DateRangePickerNew from "components/common/DateRangePicker/DateRangePickerNew";
import Header from "components/common/Header/Header";
import Breadcrumb from "components/common/Breadcrumb";
import {
  ROSTERING_INVOICING_BREADCRUMB,
  ROSTERING_INVOICING_BREADCRUMB_PAGES,
} from "Constants/BreadcrumbConstant";
import RosterModal from "./RosterModal";
import {
  getHRMTeamManagmentRequest,
  getSPParticipantsListRequest,
  spRosteringSettingsRequest,
} from "store/actions/sp.actions";
import {
  getParticipantsList,
  getTeamManagmentList,
  getSpSetting,
  getSpRosteringSetting,
} from "store/selector/sp.selector";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import RosterInvoiceTable from "./RosterInvoiceTable";
import {
  capitalizeWords,
  truncateDecimal,
  addMonths,
  getRosteringDefaultDateRange,
  formatAmount,
} from "Utils/utils";
import {
  isRequestCancelled,
  replaceAbortController,
} from "Utils/requestCancel";
import moment from "moment";
import { showClaimTypeInScheduleTimesheets } from "pages/Rostering/WorkerShift/components/advanceModeSplitDefaults";
import Pagination from "components/common/Pagination";
import { emptyPaginationObj } from "Constants/constant";
import { getParticipantLabel } from "Constants/constant";
import { useNavigate } from "react-router";
import { apiGetRequest } from "helpers/Requests";
import { URL_V5_SHIFTS_FOR_INVOICE_LIST } from "store/services/URL";
import {
  buildShiftBillingListQuery,
  formatShiftBillingCurrency,
  formatShiftBillingHours,
  isShiftInvoiceReady,
  parseShiftBillingListResponse,
  summarizeShiftBillingListPage,
  TIMESHEET_STATUS_FILTER_OPTIONS,
} from "../../UpdatedTimeSheet/TimeSheetDetailsSection/TabSection/NewCodeAllocation/v5BillingUtils";
import { resolveCreateInvoiceDisplayedShiftTotal } from "./RosterInvoiceBreakdownPanel";
import InvoicingWorkflowLayout, {
  InvoicingWorkflowFilterField,
} from "../components/InvoicingWorkflowLayout";
import { toast } from "react-toastify";

const CreateRosterInvoicing = ({
  teamManagementList,
  spParticipants,
  spRosteringSetting,
  getTeamManagmentListCall,
  getParticipantList,
  settings,
  loadSpRosteringSettings,
}) => {
  const { sideBarPadding } = React.useContext(LoginContext);
  const participantLabel = getParticipantLabel(settings?.care_sector, false);
  const participantLabelPlural = getParticipantLabel(settings?.care_sector, true);
  const [checkboxes, setCheckboxes] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [selectedWorker, setSelectedWorker] = useState(null);
  const [selectedTimesheetStatus, setSelectedTimesheetStatus] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [amount, setAmount] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [isOpenModel, setIsModelOpen] = useState(false);
  const [paginationObj, setPaginationObj] = useState(emptyPaginationObj);
  const [shiftList, setShiftList] = useState([]);
  const [listLoading, setListLoading] = useState(false);
  const listAbortRef = useRef(null);
  const listRequestIdRef = useRef(0);
  const navigate = useNavigate();

  const [perPage, setPerPage] = useState({
    label: "10",
    value: 10,
  });

  const PER_PAGE_VALUES = [
    { label: "10", value: 10 },
    { label: "20", value: 20 },
    { label: "50", value: 50 },
    { label: "100", value: 100 },
    { label: "150", value: 150 },
    { label: "300", value: 300 },
    { label: "500", value: 500 },
    { label: "750", value: 750 },
  ];

  useEffect(() => {
    const filters = {
      page: 1,
      per_page: 500,
      search: null,
    };

    getTeamManagmentListCall({ filters, bodyFilter: null });
    getParticipantList({ filters, bodyFilter: null });
    loadSpRosteringSettings();
  }, [getTeamManagmentListCall, getParticipantList, loadSpRosteringSettings]);

  useEffect(() => {
    const defaultRange = getRosteringDefaultDateRange(spRosteringSetting);
    if (!defaultRange) return;

    setFromDate(defaultRange.fromDate);
    setToDate(defaultRange.toDate);
    setSelectedFromDate(new Date(defaultRange.fromDate));
  }, [spRosteringSetting]);

  const showClaimTypeScheduleTimesheets = useMemo(
    () => showClaimTypeInScheduleTimesheets(spRosteringSetting),
    [spRosteringSetting]
  );

  const dropdownList = useMemo(() => {
    const newParticipants =
      spParticipants?.participant?.data
        ?.slice()
        .sort((a, b) => {
          const nameA = `${(a?.first_name || "").toLowerCase()} ${(a?.last_name || "").toLowerCase()}`;
          const nameB = `${(b?.first_name || "").toLowerCase()} ${(b?.last_name || "").toLowerCase()}`;
          return nameA.localeCompare(nameB);
        })
        .map((item) => ({
          label: `${capitalizeWords(item?.first_name)} ${capitalizeWords(item?.last_name || "")}`,
          value: item?.id,
        })) || [];

    const newWorkers =
      teamManagementList?.employees?.data
        ?.slice()
        .sort((a, b) => {
          const nameA = `${(a?.first_name || "").toLowerCase()} ${(a?.last_name || "").toLowerCase()}`;
          const nameB = `${(b?.first_name || "").toLowerCase()} ${(b?.last_name || "").toLowerCase()}`;
          return nameA.localeCompare(nameB);
        })
        .map((item) => ({
          label: `${item?.first_name} ${item?.last_name}`,
          value: item?.id,
        })) || [];

    return {
      participants: [{ label: "All", value: "all" }, ...newParticipants],
      workers: [{ label: "All", value: "all" }, ...newWorkers],
    };
  }, [spParticipants, teamManagementList]);

  const fetchShiftInvoiceList = useCallback(
    (page = 1) => {
      const requestId = ++listRequestIdRef.current;
      listAbortRef.current = replaceAbortController(listAbortRef.current);
      const signal = listAbortRef.current?.signal;

      setListLoading(true);
      const query = buildShiftBillingListQuery({
        page,
        perPage: perPage?.value ?? 10,
        selectedWorker,
        selectedParticipant,
        selectedTimesheetStatus,
        fromDate,
        toDate,
        ensureBilling: true,
        autoAllocate: true,
      });

      return apiGetRequest(
        `${URL_V5_SHIFTS_FOR_INVOICE_LIST}?${query}`,
        null,
        signal ? { signal } : {}
      )
        .then((res) => {
          if (requestId !== listRequestIdRef.current) return;
          const { rows, page: currentPage, per_page, total } =
            parseShiftBillingListResponse(res, {
              fallbackPage: page,
              fallbackPerPage: perPage?.value ?? 10,
            });
          setShiftList(rows);
          setPaginationObj({
            page: currentPage,
            per_page,
            total,
            totalPages: Math.ceil(total / (per_page || 1)),
          });
        })
        .catch((err) => {
          if (isRequestCancelled(err)) return;
          if (requestId !== listRequestIdRef.current) return;
          console.error("Error fetching shifts for invoice:", err);
          setShiftList([]);
          setPaginationObj(emptyPaginationObj);
        })
        .finally(() => {
          if (requestId !== listRequestIdRef.current) return;
          setListLoading(false);
        });
    },
    [perPage?.value, selectedWorker, selectedParticipant, selectedTimesheetStatus, fromDate, toDate]
  );

  useEffect(
    () => () => {
      listRequestIdRef.current += 1;
      try {
        listAbortRef.current?.abort?.();
      } catch {
        // ignore
      }
    },
    []
  );

  const handleCheckboxChange = useCallback((e, uuid, item) => {
    const rowTotal = resolveCreateInvoiceDisplayedShiftTotal(item) ?? 0;

    setCheckboxes((prev) => {
      const filteredList = prev.filter((c) => c !== uuid);
      if (e) {
        filteredList.push(uuid);
      }
      return filteredList;
    });

    if (e) {
      setQuantity((val) => val + 1);
      setAmount((prev) => truncateDecimal(parseFloat(prev || 0) + rowTotal));
    } else {
      setAmount((prev) => truncateDecimal(parseFloat(prev || 0) - rowTotal));
      setQuantity((val) => val - 1);
    }
  }, []);

  const toggleCheckboxes = (val) => {
    if (val) {
      const totalAmount = shiftList.reduce(
        (sum, data) => sum + (resolveCreateInvoiceDisplayedShiftTotal(data) ?? 0),
        0
      );

      setAmount(truncateDecimal(totalAmount));
      setQuantity(shiftList?.length || 0);
      setCheckboxes(shiftList.map((t) => t.uuid));
    } else {
      setCheckboxes([]);
      setAmount(0);
      setQuantity(0);
    }
  };

  const checkboxSet = useMemo(() => new Set(checkboxes), [checkboxes]);

  const selectedRows = useMemo(
    () => shiftList.filter((row) => checkboxSet.has(row.uuid)),
    [shiftList, checkboxSet]
  );

  const canCreateInvoice = useMemo(
    () =>
      selectedRows.length > 0 && selectedRows.every((row) => isShiftInvoiceReady(row)),
    [selectedRows]
  );

  useEffect(() => {
    if (!fromDate || !toDate) return;

    setCheckboxes([]);
    setAmount(0);
    setQuantity(0);
    fetchShiftInvoiceList(1);
  }, [
    fromDate,
    toDate,
    selectedParticipant,
    selectedWorker,
    selectedTimesheetStatus,
    perPage?.value,
    fetchShiftInvoiceList,
  ]);

  useEffect(() => {
    if (
      shiftList &&
      checkboxes &&
      checkboxes.length === shiftList.length &&
      shiftList.length !== 0
    ) {
      setAllSelected(true);
    } else {
      setAllSelected(false);
    }
  }, [checkboxes, shiftList]);

  const handleOnCreateClaimList = () => {
    const blocked = selectedRows.filter((row) => !isShiftInvoiceReady(row));
    if (blocked.length) {
      toast.error(
        "One or more shifts have $0 amount. Open Code Allocation to assign NDIS codes, then try again."
      );
      return;
    }
    setIsModelOpen(true);
  };

  const pageMetrics = useMemo(
    () => summarizeShiftBillingListPage(shiftList),
    [shiftList]
  );

  const pageBillableAmount = useMemo(
    () =>
      truncateDecimal(
        shiftList.reduce(
          (sum, row) => sum + (resolveCreateInvoiceDisplayedShiftTotal(row) ?? 0),
          0
        )
      ),
    [shiftList]
  );

  const filterSummary = useMemo(() => {
    const parts = [];

    if (fromDate && toDate) {
      parts.push(
        `${moment(fromDate).format("D MMM YY")} – ${moment(toDate).format("D MMM YY")}`
      );
    }

    if (selectedParticipant?.value && selectedParticipant.value !== "all") {
      parts.push(selectedParticipant.label);
    }

    if (selectedWorker?.value && selectedWorker.value !== "all") {
      parts.push(selectedWorker.label);
    }

    if (selectedTimesheetStatus?.value && selectedTimesheetStatus.value !== "all") {
      parts.push(selectedTimesheetStatus.label);
    }

    return parts.join(" · ") || "All shifts in date range";
  }, [fromDate, toDate, selectedParticipant, selectedWorker, selectedTimesheetStatus]);

  const billableShiftsSubValue = useMemo(() => {
    const total = paginationObj.total ?? 0;
    if (!total) return "Adjust filters to find billable shifts";

    return filterSummary;
  }, [paginationObj.total, filterSummary]);

  const pageValueSubValue = useMemo(() => {
    if (!pageMetrics.pageCount) return "No value on this page";

    return `${formatShiftBillingHours(pageMetrics.pageTotalHours)} on page`;
  }, [pageMetrics]);

  const selectedInvoiceCard = useMemo(() => {
    if (!checkboxes.length) {
      return {
        value: "—",
        label: "Selected invoice value",
        highlight: false,
      };
    }

    return {
      value: `$${formatAmount(parseFloat(amount || 0).toFixed(2))}`,
      label: "Selected invoice value",
      highlight: true,
    };
  }, [checkboxes.length, amount]);

  const workflowStats = useMemo(
    () => [
      {
        icon: HiOutlineDocumentText,
        value: paginationObj.total ?? 0,
        label: "Billable shifts",
        subValue: billableShiftsSubValue,
        iconVariant: "blue",
      },
      {
        icon: HiOutlineCurrencyDollar,
        value: formatShiftBillingCurrency(pageBillableAmount) ?? "$0.00",
        label: "Page billable value",
        subValue: pageValueSubValue,
        iconVariant: "teal",
      },
      {
        icon: HiOutlineClipboardDocumentCheck,
        value: selectedInvoiceCard.value,
        label: selectedInvoiceCard.label,
        iconVariant: "amber",
        highlight: selectedInvoiceCard.highlight,
      },
    ],
    [
      paginationObj.total,
      billableShiftsSubValue,
      pageBillableAmount,
      pageValueSubValue,
      selectedInvoiceCard,
    ]
  );

  return (
    <>
      <div className='min-h-full'>
        <SideBar />
        <div
          className={`${
            sideBarPadding
              ? "lg:pl-[4rem] duration-300"
              : "lg:pl-64 duration-300"
          }  flex flex-col`}
        >
          <main className="h-screen flex-1 bg-[#f1f5f9]">
            <Header
              breadcrumb={
                <Breadcrumb
                  pages={ROSTERING_INVOICING_BREADCRUMB(
                    ROSTERING_INVOICING_BREADCRUMB_PAGES.CREATE_ROSTER_INVOICING
                  )}
                />
              }
            />
            <InvoicingWorkflowLayout
              activeStepId="create-invoice"
              stats={workflowStats}
              headerActions={
                <>
                  <CustomButton
                    clickHandler={() => navigate("/rostering/invoicing/allocation")}
                    Icon={<BiExit />}
                    label={
                      <span className="whitespace-nowrap">
                        Go to code allocation
                      </span>
                    }
                  />
                  <CustomButton
                    variant="btn-green"
                    clickHandler={handleOnCreateClaimList}
                    Icon={<BiPlus />}
                    label={
                      <span className="whitespace-nowrap">
                        Create Invoice
                        {checkboxes.length > 0 && (
                          <small className="text-xsm font-weight-light">
                            {" "}
                            ({checkboxes.length}{" "}
                            {checkboxes.length === 1 ? "row" : "rows"})
                          </small>
                        )}
                      </span>
                    }
                    isDisabled={!canCreateInvoice}
                  />
                </>
              }
              filters={
                <>
                  <InvoicingWorkflowFilterField label={participantLabel}>
                    <SelectOption
                      isClearable={true}
                      newDesign={true}
                      isDisabled={listLoading}
                      cssClass=""
                      name="participant"
                      isSearch={true}
                      data={dropdownList?.participants}
                      selectedOption={selectedParticipant}
                      handleChange={(e) => {
                        setSelectedParticipant(e);
                      }}
                      placeHolder={`All ${participantLabel}s`}
                      maxHeight="350px"
                    />
                  </InvoicingWorkflowFilterField>
                  <InvoicingWorkflowFilterField label="Worker">
                    <SelectOption
                      isClearable={true}
                      newDesign={true}
                      isDisabled={listLoading}
                      cssClass=""
                      name="worker"
                      isSearch={true}
                      data={dropdownList?.workers}
                      selectedOption={selectedWorker}
                      handleChange={(e) => {
                        setSelectedWorker(e);
                      }}
                      placeHolder="All workers"
                      maxHeight="350px"
                    />
                  </InvoicingWorkflowFilterField>
                  <InvoicingWorkflowFilterField label="Delivered date">
                    <DateRangePickerNew
                      placeholder="Delivered Date Range"
                      isClearable={false}
                      timesheet
                      isDisabled={listLoading}
                      fromDate={fromDate}
                      toDate={toDate}
                      setSelectedFromDate={setSelectedFromDate}
                      maxDate={addMonths(selectedFromDate, 3)}
                      handleChange={(obj) => {
                        if (obj?.fromDate && obj?.toDate) {
                          setFromDate(obj.fromDate);
                          setToDate(obj.toDate);
                        }
                      }}
                    />
                  </InvoicingWorkflowFilterField>
                  <InvoicingWorkflowFilterField label="Timesheet Status">
                    <SelectOption
                      isClearable={true}
                      newDesign={true}
                      isDisabled={listLoading}
                      cssClass=""
                      name="timesheet_status"
                      isSearch={false}
                      data={TIMESHEET_STATUS_FILTER_OPTIONS}
                      selectedOption={selectedTimesheetStatus}
                      handleChange={(e) => {
                        setSelectedTimesheetStatus(e);
                      }}
                      placeHolder="All statuses"
                      maxHeight="350px"
                    />
                  </InvoicingWorkflowFilterField>
                </>
              }
            >
              <div className="iw-table-card">
                <div className="iw-table-card-header">
                  <div className="iw-table-card-heading">
                    <h2 className="iw-table-card-title">
                      Billable Shifts
                      <span className="iw-table-card-count">
                        ({paginationObj.total ?? 0})
                      </span>
                    </h2>
                    {pageMetrics.pageCount > 0 && (
                      <div className="iw-table-card-summary">
                        <span className="iw-summary-chip iw-summary-chip--value">
                          {formatShiftBillingHours(pageMetrics.pageTotalHours)} on page
                        </span>
                        {checkboxes.length > 0 && (
                          <span className="iw-summary-chip iw-summary-chip--value">
                            {checkboxes.length} selected ·{" "}
                            {formatShiftBillingCurrency(amount) ?? "$0.00"}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="iw-table-scroll is-expanded custom-scroll">
                  <table className="min-w-full divide-y divide-gray-200 border-collapse">
                    <thead className="sticky top-0 z-20 bg-[#f8fafc] capitalize">
                      <tr className="border-b border-gray-200">
                        <th
                          scope="col"
                          className="pl-4 pr-1 py-3 text-sm font-semibold text-gray-500 bg-[#f8fafc]"
                        >
                          <CheckBox
                            checked={allSelected}
                            handleChange={(e) => {
                              if (shiftList && shiftList.length > 0) {
                                setAllSelected(e);
                                toggleCheckboxes(e);
                              }
                            }}
                          />
                        </th>
                        <th
                          scope="col"
                          className="w-8 bg-[#f8fafc]"
                          aria-hidden
                        />
                        <TableHeader
                          blueBg={false}
                          isSort={false}
                          label={participantLabelPlural}
                          cssClass="normal-case"
                          innerCssClass="text-xs font-bold uppercase tracking-wide text-gray-500"
                        />
                        <TableHeader
                          blueBg={false}
                          isSort={false}
                          label="Worker"
                          innerCssClass="text-xs font-bold uppercase tracking-wide text-gray-500"
                        />
                        <TableHeader
                          blueBg={false}
                          isSort={false}
                          label="Timesheet Status"
                          cssClass="text-center whitespace-nowrap"
                          innerCssClass="text-xs font-bold uppercase tracking-wide text-gray-500"
                        />
                        <TableHeader
                          blueBg={false}
                          isSort={false}
                          label="Delivered Date"
                          cssClass="text-center"
                          innerCssClass="text-xs font-bold uppercase tracking-wide text-gray-500"
                        />
                        <TableHeader
                          blueBg={false}
                          isSort={false}
                          label="Type Of Service"
                          cssClass="text-center"
                          innerCssClass="text-xs font-bold uppercase tracking-wide text-gray-500"
                        />
                        <TableHeader
                          blueBg={false}
                          isSort={false}
                          label="Status"
                          cssClass="text-center"
                          innerCssClass="text-xs font-bold uppercase tracking-wide text-gray-500"
                        />
                        <TableHeader
                          blueBg={false}
                          isSort={false}
                          label="Quantity"
                          cssClass="text-center"
                          innerCssClass="text-xs font-bold uppercase tracking-wide text-gray-500"
                        />
                        <TableHeader
                          blueBg={false}
                          isSort={false}
                          label="Total Amount"
                          cssClass="text-center"
                          innerCssClass="text-xs font-bold uppercase tracking-wide text-gray-500"
                        />
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100 bg-white">
                      {listLoading ? (
                        <tr>
                          <td colSpan={10} className="py-16 text-center bg-[#fafbfc]">
                            <CircularLoader
                              classes="flex justify-center items-center"
                              classloader="loader-l"
                            />
                          </td>
                        </tr>
                      ) : shiftList.length > 0 ? (
                        shiftList.map((item, index) => (
                          <RosterInvoiceTable
                            isChecked={checkboxSet.has(item.uuid)}
                            onCheckboxChange={handleCheckboxChange}
                            item={item}
                            key={item.shift_uuid ?? item.uuid}
                            showClaimTypeScheduleTimesheets={
                              showClaimTypeScheduleTimesheets
                            }
                          />
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={10}
                            className="py-20 text-center text-slate-500"
                          >
                            <strong className="block text-slate-700 mb-1">
                              No shifts found
                            </strong>
                            Adjust your filters or date range to see billable
                            shifts.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {paginationObj.total > 0 && (
                  <div className="iw-table-footer">
                    <Pagination
                      newDesign={true}
                      showPerPageDropdown={true}
                      handleLimitChange={setPerPage}
                      perPageData={PER_PAGE_VALUES}
                      perPageValue={perPage}
                      page={paginationObj.page}
                      activeListLength={shiftList}
                      limit={paginationObj.per_page}
                      totalList={paginationObj.total}
                      handlePagination={(e) => {
                        setCheckboxes([]);
                        setAmount(0);
                        setQuantity(0);
                        fetchShiftInvoiceList(e);
                      }}
                      totalPages={paginationObj.totalPages}
                    />
                  </div>
                )}
              </div>
            </InvoicingWorkflowLayout>
          </main>
        </div>
      </div>
      {isOpenModel && (
        <RosterModal
          quantity={quantity}
          checkboxes={checkboxes}
          amount={amount}
          openModel={isOpenModel}
          handleClose={setIsModelOpen}
        />
      )}
    </>
  );
};

const mapDispatchToProps = {
  getTeamManagmentListCall: getHRMTeamManagmentRequest,
  getParticipantList: getSPParticipantsListRequest,
  loadSpRosteringSettings: spRosteringSettingsRequest,
};

const mapStateToProps = (state) => ({
  teamManagementList: getTeamManagmentList(state),
  spParticipants: getParticipantsList(state),
  settings: getSpSetting(state),
  spRosteringSetting: getSpRosteringSetting(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateRosterInvoicing);
